const e = {
  // Line icons
  "line/arrow-chevron-down": "phosphor/regular/caret-down",
  "line/arrow-chevron-left": "phosphor/regular/caret-left",
  "line/arrow-chevron-right": "phosphor/regular/caret-right",
  "line/arrow-chevron-up": "phosphor/regular/caret-up",
  "line/arrow-down": "phosphor/regular/arrow-down",
  "line/arrow-left": "phosphor/regular/arrow-left",
  "line/arrow-right": "phosphor/regular/arrow-right",
  "line/arrow-up": "phosphor/regular/arrow-up",
  "line/basic-shape-diamond": "phosphor/regular/diamond",
  "line/basic-shape-hexagon": "phosphor/regular/hexagon",
  "line/basic-shape-primary-circle-ellipse-round": "phosphor/regular/circle",
  "line/basic-shape-primary-square-rectangle": "phosphor/regular/square",
  "line/basic-shape-shield": "phosphor/regular/shield",
  "line/computer-device-desktop-monitor": "phosphor/regular/desktop",
  "line/computer-device-desktop": "phosphor/regular/desktop-tower",
  "line/computer-device-laptop": "phosphor/regular/laptop",
  "line/computer-device-mobile-phone-android-samsung-back": "phosphor/regular/device-mobile-camera",
  "line/computer-device-mobile-phone-android-samsung": "phosphor/regular/device-mobile",
  "line/computer-device-mobile-phone-iphone-x-back": "phosphor/regular/device-mobile-camera",
  "line/computer-device-mobile-phone-iphone-x": "phosphor/regular/device-mobile-speaker",
  "line/computer-device-mobile-tablet-touch": "phosphor/regular/hand-pointing",
  "line/computer-device-mobile-tablet": "phosphor/regular/device-tablet",
  "line/computer-device-network-ethernet-cat6": "phosphor/regular/circuitry",
  "line/computer-device-network-lan-www": "phosphor/regular/globe",
  "line/computer-device-network-wifi-connection": "phosphor/regular/wifi-high",
  "line/computer-device-network-wifi-router": "phosphor/regular/broadcast",
  "line/computer-keyboard-alt": "phosphor/regular/option",
  "line/computer-keyboard-command-cmd-control-ctrl": "phosphor/regular/command",
  "line/computer-keyboard-option": "phosphor/regular/option",
  "line/computer-keyboard-shift": "phosphor/regular/arrow-fat-up",
  "line/ecology-science-erlenmeyer-flask": "phosphor/regular/flask",
  "line/entertainment-control-button-circle-left-arrow-rewind": "phosphor/regular/rewind-circle",
  "line/entertainment-control-button-circle-pause": "phosphor/regular/pause-circle",
  "line/entertainment-control-button-circle-right-arrow-fast-forward": "phosphor/regular/fast-forward-circle",
  "line/entertainment-control-button-circle-stop-square": "phosphor/regular/stop-circle",
  "line/entertainment-control-button-play-circle": "phosphor/regular/play-circle",
  "line/entertainment-party-popper-confetti": "phosphor/regular/confetti",
  "line/image-flash-lightning": "phosphor/regular/lightning",
  "line/image-photo-frame": "phosphor/regular/image",
  "line/image-picture-flower": "phosphor/regular/image-square",
  "line/interface-add": "phosphor/regular/plus",
  "line/interface-alert-error-exclamation-block-square": "phosphor/regular/exclamation-mark",
  "line/interface-alert-error-x-block-square": "phosphor/regular/x-square",
  "line/interface-alert-exclamation-diamond": "phosphor/regular/warning-diamond",
  "line/interface-alert-exclamation-triangle-warning": "phosphor/regular/warning",
  "line/interface-alert-information-circle": "phosphor/regular/info",
  "line/interface-award-crown": "phosphor/regular/crown",
  "line/interface-bookmark-tag": "phosphor/regular/tag",
  "line/interface-bookmark": "phosphor/regular/bookmark-simple",
  "line/interface-calendar-date-one": "phosphor/regular/calendar-blank",
  "line/interface-close": "phosphor/regular/x",
  "line/interface-content-book-open-pages": "phosphor/regular/book-open",
  "line/interface-content-book-page": "phosphor/regular/book",
  "line/interface-content-file": "phosphor/regular/file",
  "line/interface-content-folder": "phosphor/regular/folder",
  "line/interface-copy-clipboard": "phosphor/regular/clipboard-text",
  "line/interface-delete-bin-trash": "phosphor/regular/trash",
  "line/interface-dots-horizontal": "phosphor/regular/dots-three-outline",
  "line/interface-dots-vertical": "phosphor/regular/dots-three-outline-vertical",
  "line/interface-edit-attachment": "phosphor/regular/paperclip",
  "line/interface-edit-binocular": "phosphor/regular/binoculars",
  "line/interface-edit-magic-wand": "phosphor/regular/magic-wand",
  "line/interface-edit-tool-eraser": "phosphor/regular/eraser",
  "line/interface-edit-tool-paint-brush": "phosphor/regular/paint-brush",
  "line/interface-edit-tool-paint-roller": "phosphor/regular/paint-roller",
  "line/interface-edit-tool-pen": "phosphor/regular/pen",
  "line/interface-edit-tool-pencil": "phosphor/regular/pencil-simple",
  "line/interface-edit-view-eye": "phosphor/regular/eye",
  "line/interface-favorite-award": "phosphor/regular/medal",
  "line/interface-favorite-flag": "phosphor/regular/flag",
  "line/interface-favorite-heart": "phosphor/regular/heart-straight",
  "line/interface-favorite-star": "phosphor/regular/star",
  "line/interface-favorite-stars-shining": "phosphor/regular/shooting-star",
  "line/interface-favorite-stars-sparkles": "phosphor/regular/sparkle",
  "line/interface-hierarchy-flowchart": "phosphor/regular/network",
  "line/interface-home-house": "phosphor/regular/house-line",
  "line/interface-hyperlink": "phosphor/regular/link",
  "line/interface-lighting-brightness": "phosphor/regular/sun",
  "line/interface-lock-closed": "phosphor/regular/lock-simple",
  "line/interface-lock-open-unlock": "phosphor/regular/lock-simple-open",
  "line/interface-login-key": "phosphor/regular/key",
  "line/interface-search": "phosphor/regular/magnifying-glass",
  "line/interface-setting-cog": "phosphor/regular/gear-six",
  "line/interface-share-megaphone-bullhorn": "phosphor/regular/megaphone",
  "line/interface-share-rocket": "phosphor/regular/rocket-launch",
  "line/interface-share-satellite": "phosphor/regular/cell-tower",
  "line/interface-share-space-ship": "phosphor/regular/flying-saucer",
  "line/interface-share": "phosphor/regular/share-network",
  "line/interface-signal-square": "phosphor/regular/pulse",
  "line/interface-text-formatting-left-open-quote": "phosphor/regular/quotes",
  "line/interface-text-formatting-right-close-quote": "phosphor/regular/quotes",
  "line/interface-time-clock-circle": "phosphor/regular/clock",
  "line/interface-time-hour-glass": "phosphor/regular/hourglass",
  "line/interface-users-multiple": "phosphor/regular/users",
  "line/interface-validation-checkbox-square": "phosphor/regular/check-square",
  "line/interface-weather-moon": "phosphor/regular/moon",
  "line/legal-justice-hammer-gavel": "phosphor/regular/gavel",
  "line/mail-chat-bubble-square": "phosphor/regular/chat-centered",
  "line/mail-send-email-paper-airplane": "phosphor/regular/paper-plane-tilt",
  "line/mail-send-envelope": "phosphor/regular/envelope",
  "line/mail-sign-hashtag": "phosphor/regular/hash",
  "line/money-cashier-receipt": "phosphor/regular/scroll",
  "line/money-currency-dollar-pay": "phosphor/regular/currency-dollar",
  "line/money-graph-arrow-increase": "phosphor/regular/trend-up",
  "line/money-graph-bar-chart-increase": "phosphor/regular/chart-bar",
  "line/nature-ecology-leaf": "phosphor/regular/leaf",
  "line/phone-telephone": "phosphor/regular/phone",
  "line/programming-bug": "phosphor/regular/bug-beetle",
  "line/programming-cloud": "phosphor/regular/cloud",
  "line/programming-computer-database-server": "phosphor/regular/hard-drives",
  "line/programming-computer-database": "phosphor/regular/database",
  "line/programming-module-four-layout": "phosphor/regular/squares-four",
  "line/programming-module-three": "phosphor/regular/circles-three",
  "line/programming-module": "phosphor/regular/cube",
  "line/programming-script-code": "phosphor/regular/code-simple",
  "line/shopping-cart": "phosphor/regular/shopping-cart",
  "line/shopping-gift-present": "phosphor/regular/gift",
  "line/shopping-shipping-box-parcel-package": "phosphor/regular/package",
  "line/tag-new-circle": "phosphor/regular/notification",
  "line/travel-map-earth-globe": "phosphor/regular/globe-hemisphere-west",
  // Solid icons
  "solid/arrow-chevron-down": "phosphor/fill/caret-down",
  "solid/arrow-chevron-left": "phosphor/fill/caret-left",
  "solid/arrow-chevron-right": "phosphor/fill/caret-right",
  "solid/arrow-chevron-up": "phosphor/fill/caret-up",
  "solid/arrow-down": "phosphor/fill/arrow-down",
  "solid/arrow-left": "phosphor/fill/arrow-left",
  "solid/arrow-right": "phosphor/fill/arrow-right",
  "solid/arrow-up": "phosphor/fill/arrow-up",
  "solid/basic-shape-diamond": "phosphor/fill/diamond",
  "solid/basic-shape-hexagon": "phosphor/fill/hexagon",
  "solid/basic-shape-primary-circle-ellipse-round": "phosphor/fill/circle",
  "solid/basic-shape-primary-square-rectangle": "phosphor/fill/square",
  "solid/basic-shape-shield": "phosphor/fill/shield",
  "solid/computer-device-desktop-monitor": "phosphor/fill/desktop",
  "solid/computer-device-desktop": "phosphor/fill/desktop-tower",
  "solid/computer-device-laptop": "phosphor/fill/laptop",
  "solid/computer-device-mobile-phone-android-samsung-back": "phosphor/fill/device-mobile-camera",
  "solid/computer-device-mobile-phone-android-samsung": "phosphor/fill/device-mobile",
  "solid/computer-device-mobile-phone-iphone-x-back": "phosphor/fill/device-mobile-camera",
  "solid/computer-device-mobile-phone-iphone-x": "phosphor/fill/device-mobile-speaker",
  "solid/computer-device-mobile-tablet-touch": "phosphor/fill/hand-pointing",
  "solid/computer-device-mobile-tablet": "phosphor/fill/device-tablet",
  "solid/computer-device-network-ethernet-cat6": "phosphor/fill/circuitry",
  "solid/computer-device-network-lan-www": "phosphor/fill/globe",
  "solid/computer-device-network-wifi-connection": "phosphor/fill/wifi-high",
  "solid/computer-device-network-wifi-router": "phosphor/fill/broadcast",
  "solid/computer-keyboard-alt": "phosphor/fill/option",
  "solid/computer-keyboard-command-cmd-control-ctrl": "phosphor/fill/command",
  "solid/computer-keyboard-option": "phosphor/fill/option",
  "solid/computer-keyboard-shift": "phosphor/fill/arrow-fat-up",
  "solid/ecology-science-erlenmeyer-flask": "phosphor/fill/flask",
  "solid/entertainment-control-button-circle-left-arrow-rewind": "phosphor/fill/rewind-circle",
  "solid/entertainment-control-button-circle-pause": "phosphor/fill/pause-circle",
  "solid/entertainment-control-button-circle-play": "phosphor/fill/play-circle",
  "solid/entertainment-control-button-circle-right-arrow-fast-forward": "phosphor/fill/fast-forward-circle",
  "solid/entertainment-control-button-circle-stop-square": "phosphor/fill/stop-circle",
  "solid/entertainment-party-popper-confetti": "phosphor/fill/confetti",
  "solid/image-flash-lightning": "phosphor/fill/lightning",
  "solid/image-photo-frame": "phosphor/fill/image",
  "solid/image-picture-flower": "phosphor/fill/image-square",
  "solid/interface-add-square": "phosphor/fill/plus",
  "solid/interface-alert-error-exclamation-block-square": "phosphor/fill/exclamation-mark",
  "solid/interface-alert-error-x-block-square": "phosphor/fill/x-square",
  "solid/interface-alert-exclamation-diamond": "phosphor/fill/warning-diamond",
  "solid/interface-alert-exclamation-triangle-warning": "phosphor/fill/warning",
  "solid/interface-alert-information-circle": "phosphor/fill/info",
  "solid/interface-award-crown": "phosphor/fill/crown",
  "solid/interface-bookmark-tag": "phosphor/fill/tag",
  "solid/interface-bookmark": "phosphor/fill/bookmark-simple",
  "solid/interface-calendar-date-one": "phosphor/fill/calendar-blank",
  "solid/interface-close": "phosphor/fill/x",
  "solid/interface-content-book-open-pages": "phosphor/fill/book-open",
  "solid/interface-content-book-page": "phosphor/fill/book",
  "solid/interface-content-file": "phosphor/fill/file",
  "solid/interface-content-folder": "phosphor/fill/folder",
  "solid/interface-copy-clipboard": "phosphor/fill/clipboard-text",
  "solid/interface-delete-bin-trash": "phosphor/fill/trash",
  "solid/interface-dots-horizontal": "phosphor/fill/dots-three-outline",
  "solid/interface-dots-vertical": "phosphor/fill/dots-three-outline-vertical",
  "solid/interface-edit-attachment": "phosphor/fill/paperclip",
  "solid/interface-edit-binocular": "phosphor/fill/binoculars",
  "solid/interface-edit-magic-wand": "phosphor/fill/magic-wand",
  "solid/interface-edit-tool-eraser": "phosphor/fill/eraser",
  "solid/interface-edit-tool-paint-brush": "phosphor/fill/paint-brush",
  "solid/interface-edit-tool-paint-roller": "phosphor/fill/paint-roller",
  "solid/interface-edit-tool-pen": "phosphor/fill/pen",
  "solid/interface-edit-tool-pencil": "phosphor/fill/pencil-simple",
  "solid/interface-edit-view-eye": "phosphor/fill/eye",
  "solid/interface-favorite-award": "phosphor/fill/medal",
  "solid/interface-favorite-flag": "phosphor/fill/flag",
  "solid/interface-favorite-heart": "phosphor/fill/heart-straight",
  "solid/interface-favorite-star": "phosphor/fill/star",
  "solid/interface-favorite-stars-shining": "phosphor/fill/shooting-star",
  "solid/interface-favorite-stars-sparkles": "phosphor/fill/sparkle",
  "solid/interface-hierarchy-flowchart": "phosphor/fill/network",
  "solid/interface-home-house": "phosphor/fill/house-line",
  "solid/interface-hyperlink": "phosphor/fill/link",
  "solid/interface-lighting-brightness": "phosphor/fill/sun",
  "solid/interface-lock-closed": "phosphor/fill/lock-simple",
  "solid/interface-lock-open-unlock": "phosphor/fill/lock-simple-open",
  "solid/interface-login-key": "phosphor/fill/key",
  "solid/interface-search": "phosphor/fill/magnifying-glass",
  "solid/interface-setting-cog": "phosphor/fill/gear-six",
  "solid/interface-share-megaphone-bullhorn": "phosphor/fill/megaphone",
  "solid/interface-share-rocket": "phosphor/fill/rocket-launch",
  "solid/interface-share-satellite": "phosphor/fill/cell-tower",
  "solid/interface-share-space-ship": "phosphor/fill/flying-saucer",
  "solid/interface-share": "phosphor/fill/share-network",
  "solid/interface-signal-square": "phosphor/fill/pulse",
  "solid/interface-text-formatting-left-open-quote": "phosphor/fill/quotes",
  "solid/interface-text-formatting-right-close-quote": "phosphor/fill/quotes",
  "solid/interface-time-clock-circle": "phosphor/fill/clock",
  "solid/interface-time-hour-glass": "phosphor/fill/hourglass",
  "solid/interface-users-multiple": "phosphor/fill/users",
  "solid/interface-validation-checkbox-square": "phosphor/fill/check-square",
  "solid/interface-weather-moon": "phosphor/fill/moon",
  "solid/legal-justice-hammer-gavel": "phosphor/fill/gavel",
  "solid/mail-chat-bubble-square": "phosphor/fill/chat-centered",
  "solid/mail-send-email-paper-airplane": "phosphor/fill/paper-plane-tilt",
  "solid/mail-send-envelope": "phosphor/fill/envelope",
  "solid/mail-sign-hashtag": "phosphor/fill/hash",
  "solid/money-cashier-receipt": "phosphor/fill/scroll",
  "solid/money-currency-dollar-pay": "phosphor/fill/currency-dollar",
  "solid/money-graph-arrow-increase": "phosphor/fill/trend-up",
  "solid/money-graph-bar-chart-increase": "phosphor/fill/chart-bar",
  "solid/nature-ecology-leaf": "phosphor/fill/leaf",
  "solid/phone-telephone": "phosphor/fill/phone",
  "solid/programming-bug": "phosphor/fill/bug-beetle",
  "solid/programming-cloud": "phosphor/fill/cloud",
  "solid/programming-computer-database-server": "phosphor/fill/hard-drives",
  "solid/programming-computer-database": "phosphor/fill/database",
  "solid/programming-module-four-layout": "phosphor/fill/squares-four",
  "solid/programming-module-three": "phosphor/fill/circles-three",
  "solid/programming-module": "phosphor/fill/cube",
  "solid/programming-script-code": "phosphor/fill/code-simple",
  "solid/shopping-cart": "phosphor/fill/shopping-cart",
  "solid/shopping-gift-present": "phosphor/fill/gift",
  "solid/shopping-shipping-box-parcel-package": "phosphor/fill/package",
  "solid/tag-new-circle": "phosphor/fill/notification",
  "solid/travel-map-earth-globe": "phosphor/fill/globe-hemisphere-west",
  // Brand icons
  "brand/brand-adobe": "phosphor/fill/paint-bucket",
  "brand/brand-amazon": "phosphor/fill/amazon-logo",
  "brand/brand-browser-firefox": "simple/firefox",
  "brand/brand-browser-googlechrome": "simple/googlechrome",
  "brand/brand-creative-commons": "simple/creativecommons",
  "brand/brand-ecommerce-etsy": "simple/etsy",
  "brand/brand-ecommerce-patreon": "simple/patreon",
  "brand/brand-ecommerce-shopify": "simple/shopify",
  "brand/brand-ecommerce-wordpress": "simple/wordpress",
  "brand/brand-gaming-nintendo-switch": "phosphor/fill/game-controller",
  "brand/brand-gaming-playstation": "simple/playstation",
  "brand/brand-gaming-xbox-live": "phosphor/fill/game-controller",
  "brand/brand-google-drive": "simple/googledrive",
  "brand/brand-google-gmail": "simple/gmail",
  "brand/brand-google": "simple/google",
  "brand/brand-music-itunes": "simple/itunes",
  "brand/brand-music-soundcloud": "simple/soundcloud",
  "brand/brand-music-spotify": "simple/spotify",
  "brand/brand-office-dropbox": "simple/dropbox",
  "brand/brand-office-slack": "simple/slack",
  "brand/brand-office-zoom": "simple/zoom",
  "brand/brand-payments-alipay": "simple/alipay",
  "brand/brand-payments-paypal": "simple/paypal",
  "brand/brand-payments-stripe": "simple/stripe",
  "brand/brand-platform-android": "simple/android",
  "brand/brand-platform-apple": "simple/apple",
  "brand/brand-platform-linux": "simple/linux",
  "brand/brand-platform-microsoft-windows": "phosphor/fill/windows-logo",
  "brand/brand-social-chat-discord": "simple/discord",
  "brand/brand-social-chat-kuaishou": "simple/kuaishou",
  "brand/brand-social-chat-line": "simple/line",
  "brand/brand-social-chat-messenger": "simple/messenger",
  "brand/brand-social-chat-signal": "simple/signal",
  "brand/brand-social-chat-snapchat": "simple/snapchat",
  "brand/brand-social-chat-telegram": "simple/telegram",
  "brand/brand-social-chat-wechat": "simple/wechat",
  "brand/brand-social-chat-whatsapp": "simple/whatsapp",
  "brand/brand-social-media-deviantart": "simple/deviantart",
  "brand/brand-social-media-dribbble": "simple/dribbble",
  "brand/brand-social-media-facebook": "simple/facebook",
  "brand/brand-social-media-instagram": "simple/instagram",
  "brand/brand-social-media-linkedin": "phosphor/fill/linkedin-logo",
  "brand/brand-social-media-pinterest": "simple/pinterest",
  "brand/brand-social-media-reddit": "simple/reddit",
  "brand/brand-social-media-sina-weibo": "simple/sinaweibo",
  "brand/brand-social-media-threads": "simple/threads",
  "brand/brand-social-media-tiktok": "simple/tiktok",
  "brand/brand-social-media-tinder": "simple/tinder",
  "brand/brand-social-media-tumblr": "simple/tumblr",
  "brand/brand-social-media-twitter": "simple/x",
  "brand/brand-software-design-figma": "simple/figma",
  "brand/brand-software-development-authy": "simple/authy",
  "brand/brand-software-development-digital-ocean": "simple/digitalocean",
  "brand/brand-software-development-docker": "simple/docker",
  "brand/brand-software-development-github": "simple/github",
  "brand/brand-software-development-jira": "simple/jira",
  "brand/brand-software-development-openai": "simple/openai",
  "brand/brand-software-development-stackexchange": "simple/stackexchange",
  "brand/brand-software-development-stackoverflow": "simple/stackoverflow",
  "brand/brand-video-netflix": "simple/netflix",
  "brand/brand-video-twitch": "simple/twitch",
  "brand/brand-video-vimeo": "simple/vimeo",
  "brand/brand-video-youtube": "simple/youtube",
  "brand/programming-framework-angular": "simple/angular",
  "brand/programming-framework-astro": "simple/astro",
  "brand/programming-framework-laravel": "simple/laravel",
  "brand/programming-framework-nextdotjs": "simple/nextdotjs",
  "brand/programming-framework-react": "simple/react",
  "brand/programming-framework-vuedotjs": "simple/vuedotjs",
  "brand/programming-language-c": "simple/c",
  "brand/programming-language-clojure": "simple/clojure",
  "brand/programming-language-csharp": "simple/c",
  "brand/programming-language-css3": "simple/css",
  "brand/programming-language-go": "simple/go",
  "brand/programming-language-html5": "simple/html5",
  "brand/programming-language-java": "phosphor/fill/coffee",
  "brand/programming-language-javascript-js": "simple/javascript",
  "brand/programming-language-json": "simple/json",
  "brand/programming-language-kotlin": "simple/kotlin",
  "brand/programming-language-node": "simple/nodedotjs",
  "brand/programming-language-objc": "simple/c",
  "brand/programming-language-ocaml": "simple/ocaml",
  "brand/programming-language-php": "simple/php",
  "brand/programming-language-powershell": "phosphor/fill/terminal-window",
  "brand/programming-language-python": "simple/python",
  "brand/programming-language-r": "simple/r",
  "brand/programming-language-ruby": "simple/ruby",
  "brand/programming-language-scala": "simple/scala",
  "brand/programming-language-shell": "simple/shell",
  "brand/programming-language-swift": "simple/swift",
  "brand/programming-language-typescript": "simple/typescript",
  "brand/programming-tool-git": "simple/git",
  "brand/programming-tool-tailwindcss": "simple/tailwindcss"
};
export {
  e as legacyIconMap
};
